import { Modal, Paragraph } from 'canoe';
import { Form, Formik } from 'formik';
import { connectWithHammock, ENDPOINTS } from 'hammock';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import styled from 'styled-components';
import { InputFields } from 'styleguide';
import * as Yup from 'yup';

import { InputField } from 'dashboard/components/Field';

const StyledModalBody = styled.div`
  overflow: visible;
`;

export const validationSchema = Yup.object().shape({
  selectedContent: Yup.string().required('Please select Content from the list'),
});

export const TemplateForm = ({ handleSubmit, content }) => {
  const [options, setOptions] = useState(content);

  return (
    <Formik
      initialValues={{ selectedContent: undefined }}
      onSubmit={({ selectedContent }) =>
        handleSubmit(content.find(({ id }) => id === selectedContent))
      }
      validationSchema={validationSchema}
    >
      <Form>
        <Modal.Header title="Create a Template" />
        <StyledModalBody>
          <Paragraph>
            Select a piece of content to add it as a Template. Everyone in your oganization will be
            able to access it.
          </Paragraph>
          <InputFields>
            <InputField
              type="select"
              label="Content"
              placeholder="Select Content"
              name="selectedContent"
              loadOptions={(search) =>
                setOptions(
                  content.filter(({ name }) => name.toLowerCase().includes(search.toLowerCase())),
                )
              }
              options={options.map(({ name, id }) => ({
                label: name,
                value: id,
              }))}
            />
          </InputFields>
        </StyledModalBody>
        <Modal.Footer
          primaryAction={{ type: 'submit', children: 'Submit', variant: 'secondary' }}
        />
      </Form>
    </Formik>
  );
};

TemplateForm.propTypes = {
  content: PropTypes.array,
  handleSubmit: PropTypes.func,
};

export default connectWithHammock({
  endpoint: ENDPOINTS.contentMetadata,
  resourceName: 'content',
})(TemplateForm);
